<template>
  <b-row>
    <b-col sm="12">
      <my-card title="Daftar Pajak">
        <template slot="button">
          <button-add v-if="cP(70)" :to="{name: 'itemtaxes-add'}" variant="primary"></button-add>
        </template>
        <template slot="body">
          <data-tables ref="datatables" endpoint="v1/item_taxes" :fields="fields">
            <template v-slot:2="{item}">
              <b-badge variant="light-primary" v-if="item[2]==1">Ya</b-badge>
              <b-badge variant="light-warning" v-else>Tidak</b-badge>
            </template>
            <template v-slot:4="data">
              <div class="float-none">
                <button-link v-if="cP(71)" size="sm" :to="{name:'itemtaxes-edit',params:{id: data.item[4]}}" feather-icon="EditIcon"></button-link>
                <button-delete v-if="cP(72)" @ondelete="deleteRow" :id="data.item[4]" :name="`${data.item[0]} (${data.item[1]})`"></button-delete>
              </div>
            </template>
          </data-tables>
        </template>
      </my-card>
    </b-col>
  </b-row>
</template>

<script>
import ButtonAdd from '@/my-components/ButtonAdd.vue'
import DataTables from '@/my-components/DataTables.vue'
import ButtonDelete from '@/my-components/ButtonDelete.vue'
import ButtonLink from '@/my-components/ButtonLink.vue'
import {BBadge} from 'bootstrap-vue'

export default {
  components:{
    ButtonAdd,
    DataTables,
    ButtonDelete,
    ButtonLink,
    BBadge
  },
  data() {
    return {
      fields: {
        0:{sortable: true, searchable: true, label:'Pajak'},
        1:{sortable: true, searchable: true, label:'Tipe'},
        2:{sortable: true, searchable: true, label:'Pajak Include'},
        3:{sortable: true, searchable: true, label:'Filter Setting'},
        4:{sortable: false, searchable: false, label:''},
      }
    }
  },
  methods:{
    async deleteRow(payload){
      try {
        await this.$store.dispatch('itemtaxes/destroy',payload)
        this.$refs.datatables.refresh()
        this.toastSuccess("OK","Data Berhasil Dihapus!")
      } catch (error) {
        this.handleError(error)
      }
    }
  }
}
</script>

<style>

</style>